import { render } from "./HorizontalAnalyticsChart.vue?vue&type=template&id=2635e01c&scoped=true"
import script from "./HorizontalAnalyticsChart.vue?vue&type=script&lang=js"
export * from "./HorizontalAnalyticsChart.vue?vue&type=script&lang=js"

import "./HorizontalAnalyticsChart.vue?vue&type=style&index=0&id=2635e01c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2635e01c"]])

export default __exports__